import React from "react";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

const InfoTooltip = ({hint, size, placement, type, ...rest}) => (
  <Tooltip
    title={hint}
    style={styles.tooltip}
    placement={placement}
    {...rest}>
    <Icon style={{ fontSize: size }}>{type}</Icon>
  </Tooltip>
)

const styles = {
  tooltip: {
    display: 'inline-flex',
    marginLeft: 8,
    textTransform: 'initial',
    fontWeight: 'bold'
  }
}

InfoTooltip.defaultProps = {
  size: 16,
  placement: 'top',
  type: 'info'
}

export default InfoTooltip



// WEBPACK FOOTER //
// ./src/components/support/info-tooltip/index.jsx